var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-video-lecture" }, [
    _c("div", { staticClass: "edit-video-lecture__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "edit-video-lecture__header-title typography--color-primary text-center"
            },
            [
              _vm.lecture
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.edit_video_lecture.title")
                        ) +
                        "\n          "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("publishers.modal.new_video_lecture.title")
                        ) +
                        "\n          "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _vm.videoEmbed
            ? _c(
                "div",
                { staticClass: "edit-video-lecture__video-preview w-100" },
                [
                  _c("div", {
                    staticClass: "w-100",
                    domProps: { innerHTML: _vm._s(_vm.videoEmbed) }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c("LoadingBounce"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-2 typography--color-disabled pb-5"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.loading")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "edit-video-lecture__form" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "subject-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.modal.new_series.subject")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.subjectId,
                          expression: "subjectId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "subject-select",
                        disabled: _vm.subjectSelectDisabled
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.subjectId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.onSubjectSelect
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.new_series.subject_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.subjectIds.filter(function(id) {
                          return id !== "0" && id !== "9999"
                        }),
                        function(sjId) {
                          return _c(
                            "option",
                            { key: sjId, domProps: { value: sjId } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getTranslatedName(_vm.subjectMap[sjId])
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "grade-select" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("publishers.modal.new_series.grade")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gradeId,
                          expression: "gradeId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "grade-select",
                        disabled: _vm.gradeSelectDisabled
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.gradeId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.new_series.grade_placeholder"
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.gradeIds.filter(function(id) {
                          return id !== "0" && id !== "9999"
                        }),
                        function(gId) {
                          return _c(
                            "option",
                            { key: gId, domProps: { value: gId } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getTranslatedName(_vm.gradeMap[gId])
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDomainSelect,
                        expression: "showDomainSelect"
                      }
                    ],
                    staticClass: "form-group"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary typography--font-weight-600",
                        attrs: { for: "domain-select" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("publishers.modal.chapter_edit.domain")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.domainId,
                            expression: "domainId"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "domain-select",
                          disabled: _vm.domainSelectDisabled
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.domainId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.onDomainSelect
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "publishers.modal.chapter_edit.domain_placeholder"
                                )
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.domainList, function(domain) {
                          return _c(
                            "option",
                            { key: domain.id, domProps: { value: domain.id } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(domain.name) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showDomainConceptSelect,
                        expression: "showDomainConceptSelect"
                      }
                    ],
                    staticClass: "form-group"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary typography--font-weight-600",
                        attrs: { for: "domain-concept-select" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "publishers.modal.chapter_edit.domain_concept"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.domainConceptId,
                            expression: "domainConceptId"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "domain-concept-select" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.domainConceptId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "publishers.modal.chapter_edit.domain_concept_placeholder"
                                )
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.domainConceptList, function(concept) {
                          return _c(
                            "option",
                            {
                              key: concept.id,
                              domProps: { value: concept.id }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(concept.name) +
                                  "\n              "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "video-lecture-title-input" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("publishers.modal.new_series.name")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.lectureTitle,
                        expression: "lectureTitle",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "video-lecture-title-input",
                      maxlength: "50",
                      placeholder: _vm.$t(
                        "publishers.modal.new_series.name_placeholder"
                      )
                    },
                    domProps: { value: _vm.lectureTitle },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.lectureTitle = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600",
                      attrs: { for: "video-lecture-description-input" }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("publishers.modal.new_series.description")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lectureDescription,
                        expression: "lectureDescription"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "video-lecture-description-input",
                      rows: "5",
                      maxlength: "500",
                      placeholder: _vm.$t(
                        "publishers.modal.new_series.description_placeholder"
                      )
                    },
                    domProps: { value: _vm.lectureDescription },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.lectureDescription = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group pb-4" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary typography--font-weight-600"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "publishers.modal.edit_video_lecture.share_level"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-6" },
                    [
                      _c(
                        "ToggleSwitch",
                        {
                          attrs: {
                            id: "share-level-switch",
                            "model-value": _vm.shareLevel,
                            "check-value": 1
                          },
                          on: { change: _vm.toggleShareLevel }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getShareLevelLabel(_vm.shareLevel || 2)
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.lecture
                  ? _c("div", { staticClass: "text-center mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-full edit-video-lecture__create-btn",
                          attrs: { disabled: _vm.newLectureDisabled },
                          on: {
                            click: function($event) {
                              return _vm.update()
                            }
                          }
                        },
                        [
                          !_vm.busy
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("common.save")))
                              ])
                            : _c("LoadingBounce")
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "text-center mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-full edit-video-lecture__create-btn",
                          attrs: { disabled: _vm.newLectureDisabled },
                          on: {
                            click: function($event) {
                              return _vm.create()
                            }
                          }
                        },
                        [
                          !_vm.busy
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "video_lectures.new_video_course.create"
                                    )
                                  )
                                )
                              ])
                            : _c("LoadingBounce")
                        ],
                        1
                      )
                    ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center mt-2" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn btn-secondary btn-full edit-video-lecture__cancel-btn typography--color-secondary",
                        attrs: { to: _vm.prevLink }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("btn.redirect_to_root")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd4df9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fd4df9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lectures/views/EditVideoLecture.vue
// module id = 0Eyt
// module chunks = 1